import React from 'react';
import useShots from '../../../../hooks/use-shots';
import { useSelector } from 'react-redux';
import { GreenroomState } from '../../../../stores/types/types';
import { showAlert } from '../../../general-components/alert-service';
import { ALERT_TYPES } from '../../../general-components/alert-types';
import TextInput from '../../../general-components/text-input';
import colors from '../../../../utils/colors';

const alerts = [
	'error',
	'warning',
	'neutral',

	'media-device',
	'mic-update',
	'cam-update',
	'speaker-update',
	'scheduled-stream-notification',
	'scheduled-stream-schedule-error',
	'autoplay-notification',
	'duration-notification',
	'media-title-error',
	'presenter-cap',
	'general-notification',
	'general-error',
]

export default function DebugAlerts() {
	const {currentShot: { shot_data: { shotGraphics } }} = useShots();

	const [duration, setDuration] = React.useState<number>(5000)
	const [message, setMessage] = React.useState<string>('Title Text')
	const [description, setDescription] = React.useState<string>('Testing description text')

	const fireAlert = (type: string | ALERT_TYPES) => {
		const props = {type, duration: duration} as any;
		if (message) {
			props.message = message;
		}
		if (description) {
			props.description = description;
		}
		showAlert(props)
	}

	return (<div>
		<div className='margin-top-small'>Title <input 
			className='margin-top-small'
			onChange={(e) => setMessage(e.target.value)}
			value={message}
			style={{minWidth: '70%'}}
		/></div>
		<div className='margin-top-small'>Body <input 
			onChange={(e) => setDescription(e.target.value)}
			value={description}
			style={{minWidth: '70%'}}
		/></div>
		<div className='margin-top-small'>MS {duration} <input 
			value={duration}
			type='range'
			min={3000}
			max={30000}
			step={100}
			onChange={(e) => {setDuration(Number.parseInt(e.target.value, 10))}}
			style={{
				backgroundColor: colors.blGrayscale700,
				maxWidth: '70%',
				padding: '2px 0'
			}}
		/></div>
		<button onClick={() => fireAlert(ALERT_TYPES.WARNING)}>ALERT_TYPES.WARNING</button>
		<button onClick={() => fireAlert(ALERT_TYPES.ERROR)}>ALERT_TYPES.ERROR</button>
		<button onClick={() => fireAlert(ALERT_TYPES.NEUTRAL)}>ALERT_TYPES.NEUTRAL</button>
		<button onClick={() => fireAlert(ALERT_TYPES.POSITIVE)}>ALERT_TYPES.POSITIVE</button>
		<button onClick={() => fireAlert(ALERT_TYPES.CHAT)}>ALERT_TYPES.CHAT</button>
		<button onClick={() => fireAlert(ALERT_TYPES.MEDIA_DEVICE)}>ALERT_TYPES.MEDIA_DEVICE</button>
		<button onClick={() => fireAlert(ALERT_TYPES.MEDIA_UPLOADED)}>ALERT_TYPES.MEDIA_UPLOADED</button>
		<button onClick={() => fireAlert(ALERT_TYPES.MEDIA_TITLE_ERROR)}>ALERT_TYPES.MEDIA_TITLE_ERROR</button>
		<button onClick={() => fireAlert(ALERT_TYPES.PRESENTER_CAP)}>ALERT_TYPES.PRESENTER_CAP</button>
		{alerts.map((s) => <button onClick={() => fireAlert(s)}>'{s}'</button>)}
	</div>);
}